<script>
	import { createEventDispatcher, onMount, onDestroy } from 'svelte';
	import { replace, push } from 'svelte-spa-router';
	import TBox from '../templates/TBox.svelte';
	import { 
		StatusHttp, 
		TipoEvento,
		API, 
TextoFeedback} from '../../utils';

	const dispatch = createEventDispatcher();
	
	// variáveis para trabalhar com os dados do formulário
	let email, senha, senhaConfirmacao;

	let tituloAviso = "Erro";
	let feedbackUsuario = [];
	let flagResetSenha = null;

	onMount(async () => {
		flagResetSenha = localStorage.getItem('AVAL_FLAG_RESETSENHA');

		if (flagResetSenha === null)
			push('/');
	});

	async function submeterFormulario() {
		dispatch('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Atualizando ...'
		});
		
		const resposta = await fetch(API('credenciais/atualizacao'), {
			method: 'PATCH',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				flag: flagResetSenha,
				senha: senha,
				senha_confirmacao: senhaConfirmacao,
			})
		}).catch(erros => {
			feedbackUsuario.push(TextoFeedback.ERRO_REQUISICAO);
		});

		// pega o json do retorno da resposta
		const json = await resposta.json();

		switch (resposta.status) {
			case StatusHttp.OK:
				tituloAviso = 'Tudo certo!';
				feedbackUsuario.push(json?.mensagem);

				// aguarda um pouco antes de redirecionar devido o localstorage levar um tempo pra escrever (síncrono)
				setTimeout(() => {
					// redireciona pra tela de login
					replace('/login');
				}, 1000);

				break;
			case StatusHttp.BAD_REQUEST:
				feedbackUsuario.push(json?.mensagem);
				break;
			case StatusHttp.HTTP_NOT_FOUND:
				feedbackUsuario.push(json?.mensagem);
				break;
			default:
				console.log('erro desconhecido...');
				feedbackUsuario.push('Erro desconhecido, se persistir, favor entrar em contato.');
		}
		
		dispatch('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});

		// exibe feedback pro usuário se existir algo pra exibir
		if (feedbackUsuario[0]) {
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: tituloAviso,
				conteudo: feedbackUsuario[0]
			});
		}

		// limpa as mensagens
		feedbackUsuario = [];
	}

	onDestroy(() => {
		// console.log('ResetSenha destruido...');

		// apaga o flag do localstorage
		localStorage.removeItem('AVAL_FLAG_RESETSENHA');
	});
</script>

<style></style>

<TBox 
	titulo="Crie uma nova senha" 
	subtitulo="Utilize o formulário abaixo para criar uma nova senha" 
	largura="6" 
	deslocamento="3" 
	correcaoY="-13px"
	icone="recuperacao">

	<p>
		Utilize os campos abaixo para criar uma nova senha. Evite senhas óbvias, sob risco de utilização inadequada do sistema.
		<small>Aprenda como criar senhas fortes <a href="https://support.google.com/accounts/answer/32040?hl=pt-BR" target="_blank">clicando aqui</a></small>.
	</p>

	<hr>

	<form method="post" on:submit|preventDefault={submeterFormulario}>
		<div class="columns">
			<div class="column">
				<div class="field">
					<input 
						bind:value={senha}
						name="senha" 
						type="password" 
						placeholder="Digite a nova senha aqui" 
						class="input is-large is-primary has-text-weight-bold" required>
				</div>
			</div>
		</div>

		<div class="columns">
			<div class="column">
				<div class="field">
					<input 
						bind:value={senhaConfirmacao}
						name="senha_confirmacao" 
						type="password" 
						placeholder="Digite novamente ..." 
						class="input is-large is-primary has-text-weight-bold" required>
				</div>
			</div>
		</div>

		<div class="columns">
			<div class="column">
				<p class="control">
					<button 
						type="submit" 
						class="button is-dark is-large is-fullwidth">
						Atualizar
					</button>
				</p>
			</div>
		</div>
	</form>

	<br>
	<br>

	<div class="has-text-centered">
		<a href="#/" class="button is-dark is-medium is-outlined">Início</a>
		<a href="#/suporte" class="button is-primary is-medium">Suporte</a>
	</div>
</TBox>